export default __webpack_public_path__ + "static/media/backupLogo.b1d25f43.jpg";